import _classCallCheck from "/home/bcl-presale-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/bcl-presale-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/home/bcl-presale-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/home/bcl-presale-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";
import { Subscribable } from './subscribable.esm.js';
import { isServer } from './utils.esm.js';

var OnlineManager = /*#__PURE__*/function (_Subscribable) {
  _inherits(OnlineManager, _Subscribable);

  var _super = _createSuper(OnlineManager);

  function OnlineManager() {
    var _this;

    _classCallCheck(this, OnlineManager);

    _this = _super.call(this);

    _this.setup = function (onOnline) {
      // addEventListener does not exist in React Native, but window does
      // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
      if (!isServer && window.addEventListener) {
        var listener = function listener() {
          return onOnline();
        }; // Listen to online


        window.addEventListener('online', listener, false);
        window.addEventListener('offline', listener, false);
        return function () {
          // Be sure to unsubscribe if a new handler is set
          window.removeEventListener('online', listener);
          window.removeEventListener('offline', listener);
        };
      }

      return;
    };

    return _this;
  }

  _createClass(OnlineManager, [{
    key: "onSubscribe",
    value: function onSubscribe() {
      if (!this.cleanup) {
        this.setEventListener(this.setup);
      }
    }
  }, {
    key: "onUnsubscribe",
    value: function onUnsubscribe() {
      if (!this.hasListeners()) {
        var _this$cleanup;

        (_this$cleanup = this.cleanup) == null ? void 0 : _this$cleanup.call(this);
        this.cleanup = undefined;
      }
    }
  }, {
    key: "setEventListener",
    value: function setEventListener(setup) {
      var _this2 = this;

      var _this$cleanup2;

      this.setup = setup;
      (_this$cleanup2 = this.cleanup) == null ? void 0 : _this$cleanup2.call(this);
      this.cleanup = setup(function (online) {
        if (typeof online === 'boolean') {
          _this2.setOnline(online);
        } else {
          _this2.onOnline();
        }
      });
    }
  }, {
    key: "setOnline",
    value: function setOnline(online) {
      this.online = online;

      if (online) {
        this.onOnline();
      }
    }
  }, {
    key: "onOnline",
    value: function onOnline() {
      this.listeners.forEach(function (listener) {
        listener();
      });
    }
  }, {
    key: "isOnline",
    value: function isOnline() {
      if (typeof this.online === 'boolean') {
        return this.online;
      }

      if (typeof navigator === 'undefined' || typeof navigator.onLine === 'undefined') {
        return true;
      }

      return navigator.onLine;
    }
  }]);

  return OnlineManager;
}(Subscribable);

var onlineManager = new OnlineManager();
export { OnlineManager, onlineManager };